import { 
    gql, 
    useQuery 
} from "@apollo/client";
import { 
    CustomerTier, 
    PointsCardQueryQuery 
} from "../../../schemaTypes";

export const pointsCardQuery = gql`
  query PointsCardQuery {
    pointsCard {
      customerTier
      lifeTimePoint
      pointBalance
      currentMonthPoints
      pointsForNextTier
      tiers{
        name
        threshold
      }
    }
  }
`;

export interface WithPointsCard {
  customerTier: string;
  lifeTimePoint: number;
  pointBalance: number;
  currentMonthPoints: number;
  pointsForNextTier: number;
  tiers: CustomerTier[];
  loading: boolean;
}

export const usePointCard = (): WithPointsCard => {
  const { data, loading } = useQuery<
    PointsCardQueryQuery
  >(pointsCardQuery);

  if (!data?.pointsCard) {
    return {
      customerTier: "",
      lifeTimePoint: 0,
      pointBalance: 0,
      currentMonthPoints: 0,
      pointsForNextTier: 0,
      tiers: [],
      loading,
    };
  }

  const pointCardData = data.pointsCard;

  return {
    customerTier: pointCardData.customerTier ?? "",
    lifeTimePoint: pointCardData.lifeTimePoint ?? 0,
    pointBalance: pointCardData.pointBalance ?? 0,
    currentMonthPoints: pointCardData.currentMonthPoints ?? 0,
    pointsForNextTier: pointCardData.pointsForNextTier ?? 0,
    tiers: (pointCardData.tiers?.filter((p): p is CustomerTier => p !== null) || []) as CustomerTier[],
    loading,
  };
};